import { appPaths } from '@/app/router/paths.js';

/** Finance screens that require a company (CNPJ) registration. */
export const INDIVIDUAL_HIDDEN_FINANCE_CHILD_IDS: ReadonlySet<string> = new Set([
  'finance-collection-charges',
  'finance-bank-reconciliation',
  'finance-income-statement',
  'finance-chart-of-accounts',
  'finance-inbound-charge-policy',
]);

const INDIVIDUAL_HIDDEN_FINANCE_PREFIXES = [
  appPaths.financeCollectionCharges,
  appPaths.financeBankReconciliation,
  appPaths.financeIncomeStatement,
  appPaths.financeChartOfAccounts,
  appPaths.financeInboundChargePolicy,
] as const;

export function isIndividualHiddenFinancePath(pathname: string): boolean {
  return INDIVIDUAL_HIDDEN_FINANCE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
